export default {
      id: "growing-up-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#growing-up",
      toString: function () {
        return this.url;
      }
    }